/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { getCart } from "../../Utils/cart-service";
import AppContext from "../../Utils/appContext";
import { useNavigate } from "react-router-dom";
import { vibrate } from "../../Utils/util-service";
import "./HeaderOptions.css";

const HeaderOptions = ({ hideCart, hideProfile, showHome }) => {
  const navigate = useNavigate();
  const { cartLength } = React.useContext(AppContext);
  const [length, setLength] = React.useState();

  const goTo = (path) => {
    vibrate(20);
    navigate(path);
  };

  React.useEffect(() => {
    const carts = getCart();
    setLength(carts?.length);
  }, [cartLength]);

  return (
    <div
      className={`header-option${showHome ? " header-option-labeled" : ""}`}
    >
      <ul>
        {!hideCart && (
          <li>
            <a onClick={() => goTo("/search")}>
              <i className="iconly-Search icli"></i>
            </a>
          </li>
        )}
        {!hideProfile && (
          <li>
            <a onClick={() => goTo("/profile")}>
              <i className="iconly-Profile icli"></i>
            </a>
          </li>
        )}
        {!hideCart && (
          <li>
            <a onClick={() => goTo("/cart")}>
              <i className="iconly-Buy icli"></i>
            </a>
            {length > 0 && <span id="cart_bottom_header">{length}</span>}
          </li>
        )}
        {showHome && (
          <>
            <li>
              <a onClick={() => goTo("/search")}>
                <div className="icon">
                  <i className="iconly-Search icli"></i>
                </div>
                <span>Search</span>
              </a>
            </li>
            <li>
              <a onClick={() => goTo("/categories")}>
                <div className="icon">
                  <i className="iconly-Category icli"></i>
                </div>
                <span>Category</span>
              </a>
            </li>
            <li>
              <a onClick={() => goTo("/")}>
                <div className="icon">
                  <i className="iconly-Home icli"></i>
                </div>
                <span>Home</span>
              </a>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default HeaderOptions;
